// function importAll(r) {
//   r.keys().forEach(r)
// }
//
// importAll(require.context("../../blocks/", true, /\/script\.js$/))
import hamburger from './components/hamburger';
import anchorScroll from './components/anchorScroll';
import scrollToUp from './components/scrollToUp';
import removeOrphans from "./components/removeOrphans";
import sal from 'sal.js';
import { initBlock } from './blocks';

const blockNames = [
  "cards",
  "cta",
  "features",
  "form",
  "hero",
  "section",
  "text-with-image"
];

for (const item of blockNames) {
  initBlock(item).then((blocks) => {});
}

window.addEventListener('DOMContentLoaded', () => {
  hamburger()
  anchorScroll()
  scrollToUp()
  removeOrphans()
})

sal({
  once: true,
})